import { lazy } from 'react';
import {
	createRootRoute,
	createRouter,
	createRoute,
	AnyRoute,
} from '@tanstack/react-router';

import config from '@/config';
import { basepath } from '@/constants';

import { AUTH_KEY } from '@/views/home/auth/Authentication.hooks';
import { issueSearchSchema } from '@/views/issue/Issue.hooks';
import { logOut } from './auth/Auth.hooks';

import { NotFound, RootRouteComponent } from '@/views/RootRoute';

// Lazy loaded routes
const LazyPreview = lazy(() => import('@/components/preview/Preview'));
const LazyDrafts = lazy(() => import('@/views/drafts/Drafts'));
const LazyIssue = lazy(() => import('@/views/issue/Issue'));
const LazyHome = lazy(() => import('./home/Home'));
const LazyLogout = lazy(() => import('./auth/Logout'));
const LazyCallback = lazy(() => import('./callback/Callback'));
const LazySubscriptions = lazy(() => import('./subscriptions/Subscriptions'));
const LazySuccess = lazy(() => import('./subscriptions/success/Success'));

/* Routes declaration */

const rootRoute = createRootRoute({
	component: RootRouteComponent,
});

const onClickLogOut = localStorage.getItem(AUTH_KEY)
	? (url?: string): void => {
			console.log(`Click logout to the followin url: ${url}`);
			logOut(url || '/logout');
	  }
	: undefined;

const indexRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/',
	component: () => <LazyHome onClickLogOut={onClickLogOut} />,
});

const issueRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: () => <LazyIssue onClickLogOut={onClickLogOut} />,
	validateSearch: issueSearchSchema,
	path: 'issues/$id',
});

const issueArticleRoute = createRoute({
	getParentRoute: () => issueRoute,
	component: () => <LazyIssue onClickLogOut={onClickLogOut} />,
	validateSearch: issueSearchSchema,
	path: '$articleId',
});

const previewRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: LazyPreview,
	path: 'preview/$id',
});

const subscriptionsRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: LazySubscriptions,
	path: 'subscriptions',
});

const subscriptionsSuccessRoute = createRoute({
	getParentRoute: () => subscriptionsRoute,
	component: LazySuccess,
	path: 'success',
});

const callbackRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: LazyCallback,
	path: 'callback',
});

const logOutRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: LazyLogout,
	path: 'logout',
});

const draftsRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: LazyDrafts,
	path: 'drafts',
});

/* END of routes declaration */

const routes: Array<AnyRoute> = [
	indexRoute,
	issueRoute,
	issueArticleRoute,
	previewRoute,
	subscriptionsRoute,
	subscriptionsSuccessRoute,
	callbackRoute,
	logOutRoute,
];

if (config?.app?.admin) {
	routes.push(draftsRoute);
}

const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
	routeTree,
	basepath,
	defaultNotFoundComponent: NotFound,
});
